import { render, staticRenderFns } from "./JoinSuccess.vue?vue&type=template&id=9116f640&scoped=true"
import script from "./JoinSuccess.vue?vue&type=script&lang=ts"
export * from "./JoinSuccess.vue?vue&type=script&lang=ts"
import style0 from "./JoinSuccess.vue?vue&type=style&index=0&id=9116f640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9116f640",
  null
  
)

export default component.exports